import { useCallback, useState } from "react";
import { useLocation, useNavigate, useBlocker } from "react-router";

export function useCallbackPrompt(when) {
  const navigate = useNavigate();
  const location = useLocation();
  const [showPrompt, setShowPrompt] = useState(false);
  const [lastLocation, setLastLocation] = useState(null);

  const cancelNavigation = useCallback(() => {
    setShowPrompt(false);
    setLastLocation(null);
  }, []);

  const handleBlockedNavigation = useCallback(
    (args) => {
      if (when) {
        if (args.historyAction != "POP" && args.nextLocation.state?.skipBlocker)
          return false;
        if (args.nextLocation.pathname !== args.currentLocation.pathname) {
          setShowPrompt(true);
          setLastLocation(args.nextLocation);
          return true;
        }
        return false;
      }
    },
    [when, location],
  );

  const confirmNavigation = useCallback(() => {
    setShowPrompt(false);
    if (lastLocation)
      navigate(lastLocation.pathname, {
        state: { skipBlocker: true },
      });
  }, [lastLocation, location]);

  useBlocker(handleBlockedNavigation);

  return [showPrompt, confirmNavigation, cancelNavigation];
}
